module.exports = __webpack_public_path__ + "img/b331ef7.png";